import { render } from "./Gun.vue?vue&type=template&id=fd8d18c2"
import script from "./Gun.vue?vue&type=script&lang=js"
export * from "./Gun.vue?vue&type=script&lang=js"

import exportComponent from "/Users/Junior/ProjectPile/smartpile-h5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__